// extracted by mini-css-extract-plugin
module.exports = {"flexboxPaneContainer":"FlexboxPane_flexboxPaneContainer__sQHg1","flexboxPaneChild":"FlexboxPane_flexboxPaneChild__X6hok"};